import { c as _objectWithoutPropertiesLoose } from './chunk-fb907809.js';
import React__default, { createElement, Component } from 'react';
import PropTypes__default, { func, string, oneOfType, arrayOf, bool, number, oneOf, object, objectOf, node } from 'prop-types';
import { theme } from 'styled-tools';
import { a as bool$1, b as bgColorWithProps, c as textColorWithProps } from './chunk-a44fd1b3.js';
import styled from './styled.js';
import as from './as.js';
import './chunk-a7ce379e.js';
import 'styled-components';
import '@emotion/is-prop-valid';
import 'hoist-non-react-statics';

var positions = {
  static: "static",
  absolute: "absolute",
  fixed: "fixed",
  relative: "relative",
  sticky: "sticky"
};

var Component$1 = function Component$$1(_ref) {
  var T = _ref.as,
      props = _objectWithoutPropertiesLoose(_ref, ["as"]);

  return createElement(T, props);
};

var positionsKeys = Object.keys(positions);
var Box = styled(Component$1).withConfig({
  displayName: "Box",
  componentId: "sc-1tbf5pj-0"
})(["margin:unset;padding:unset;border:unset;background:unset;font:unset;font-family:inherit;font-size:100%;box-sizing:border-box;background-color:", ";color:", ";", ";&&&{", ";}"], bgColorWithProps, textColorWithProps, theme("Box"), bool$1("position", positionsKeys));
var asTypes = [func, string]; // @ts-ignore

Box.propTypes = {
  as: oneOfType(asTypes.concat([arrayOf(oneOfType(asTypes))])),
  opaque: bool,
  palette: string,
  tone: number,
  static: bool,
  absolute: bool,
  fixed: bool,
  relative: bool,
  sticky: bool
};
var Box$1 = as("div")(Box);

export default Box$1;
